import React from "react";
import PageHeading from "../../../../components/common/PageHeading";
import SubHeading from "../../../../components/common/SubHeading";
import RightBar from "../../../../components/common/RightBar";
import Footer from "../../../../components/common/Footer";

import { Button, Col, Form, InputNumber, Popover, Row } from "antd";
import { TbCurrencyDollar } from "react-icons/tb";
import { FaQuestionCircle } from "react-icons/fa";

import './BulkUpdateApplicationFees.css';

const popoverContent = (
  <p className="common-paragraph para">This fee will be displayed as the application processing fee on your online applications. AppFolio will deduct a $5 transaction fee from this amount. The application fee must be at least $6 and cannot be more than $200.</p>
);

const UpdateApplicationFeesRightBar = [];

function BulkUpdateApplicationFees() {
  return (
   <>
      <div className="update-application-fees main-container">
        <PageHeading heading="Bulk Update Application Fees" />
        <Row>
          <Col span={24}>
            <h4>2 units + 0 hidden units will be updated.</h4>
            <p className="common-paragraph p">
              Please ensure this is the expected number of units before you
              proceed.
            </p>
            <SubHeading subHeading="Set New Fee Amount" />
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              className="fees-form"
            >
              <Form.Item
                label={
                  <span className="plain-text">
                    Application Fee{" "}
                    <Popover trigger="click" content={popoverContent} title="Application Fees">
                      <FaQuestionCircle size={12} className="circled-question" />  
                    </Popover> {" "}
                  </span>
                }
              >
                <InputNumber addonBefore={<TbCurrencyDollar size={16} />} />
              </Form.Item>
              <Button type="primary">Update Fees</Button>
            </Form>
          </Col>
        </Row>
        <Footer />
      </div>
    <div className="RightSidebar">
      <RightBar RightBarData={UpdateApplicationFeesRightBar} />
    </div>
   </>
  );
}

export default BulkUpdateApplicationFees;
